module.exports = __webpack_public_path__ + "static/img/tool_edit_img.4a9c0ed0.png";